import React from 'react';

interface DataTableRowProps {
  row: any;
  details?: any;
  rowProps?: React.HTMLAttributes<HTMLTableRowElement>;
}

export const DataTableRow = ({ row, details, rowProps }: DataTableRowProps) => {
  return (
    <>
      <tr {...rowProps}>{row}</tr>

      {details && <tr>{details}</tr>}
    </>
  );
};

export default DataTableRow;
